class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// Only bind hover-to-open on devices that actually have a mouse: touch
// taps fire a synthetic mouseenter too, and without this guard a tap would
// open the menu AND leave it stuck open (no mouseleave ever follows a tap).
const HEADER_MENU_HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Opens on hover in addition to the native click-to-toggle <details>
    // behavior inherited from DetailsDisclosure above. Bound to the whole
    // custom element (summary + dropdown panel together, per
    // "header-menu > details { position: relative }" / ".mega-menu__content
    // { position: absolute; top: 100% }" in base.css, which sit flush
    // against each other) so moving the pointer from the nav label down
    // into the panel never crosses a gap and closes it prematurely.
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    if (!HEADER_MENU_HOVER.matches) return;
    window.clearTimeout(this.hoverCloseTimeout);

    // Close any other open top-level menu first so two menus never overlap
    // mid-transition when the pointer moves directly from one nav item to
    // the next (mouseleave on the old one would otherwise fire on its own
    // delay, after this one has already opened).
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle.open) menu.close();
    });

    this.mainDetailsToggle.open = true;
  }

  onMouseLeave() {
    if (!HEADER_MENU_HOVER.matches) return;
    // Small delay rather than closing instantly: guards against a brief,
    // unintentional dip outside the bounding box (e.g. a slightly diagonal
    // mouse path) being read as "left the menu".
    this.hoverCloseTimeout = window.setTimeout(() => this.close(), 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);